import React from 'react';
import { Trophy, Medal, Award } from 'lucide-react';
import { Avatar } from '../ui/Avatar';
import { Card } from '../ui/Card';
interface MemberCardProps {
  rank: number;
  name: string;
  metric: string;
  metricLabel: string;
  avatarUrl?: string;
  isAnonymous?: boolean;
}
export function MemberCard({
  rank,
  name,
  metric,
  metricLabel,
  avatarUrl,
  isAnonymous
}: MemberCardProps) {
  const getRankIcon = (r: number) => {
    switch (r) {
      case 1:
        return <Trophy className="text-yellow-500" size={20} data-id="element-81" />;
      case 2:
        return <Medal className="text-gray-400" size={20} data-id="element-82" />;
      case 3:
        return <Medal className="text-orange-700" size={20} data-id="element-83" />;
      default:
        return <span className="text-gray-400 font-bold w-5 text-center" data-id="element-84">{r}</span>;
    }
  };
  const displayName = isAnonymous ? 'Aluno Misterioso' : name;
  const displayAvatar = isAnonymous ? undefined : avatarUrl;
  return <div className="flex items-center gap-3 p-3 bg-white rounded-xl border border-gray-100 shadow-sm mb-2" data-id="element-85">
      <div className="flex items-center justify-center w-8 h-8 flex-shrink-0" data-id="element-86">
        {getRankIcon(rank)}
      </div>

      <Avatar src={displayAvatar} alt={displayName} fallback={isAnonymous ? '?' : undefined} data-id="element-87" />

      <div className="flex-1 min-w-0" data-id="element-88">
        <h4 className="font-bold text-gray-900 truncate text-sm" data-id="element-89">
          {displayName}
        </h4>
        <p className="text-xs text-gray-500 truncate" data-id="element-90">
          {rank === 1 ? 'Campeão do Mês' : `Top ${rank} da Academia`}
        </p>
      </div>

      <div className="text-right" data-id="element-91">
        <span className="block font-bold text-[var(--primary)] text-lg leading-none" data-id="element-92">
          {metric}
        </span>
        <span className="text-[10px] text-gray-400 uppercase font-medium" data-id="element-93">
          {metricLabel}
        </span>
      </div>
    </div>;
}